import { ValidationProtocolDTO } from "../DTO/validationProtocolDTO";
import { FieldDefinition } from "./fieldDefinition";
import { ValidationRule } from "./validationRule";
import { ValidationRuleDefinition } from "./validationRuleDefinition";

export class ValidationProtocol {

    public id!: number;
    public sequenceNo!: number;
    public validationRules!: ValidationRule[];
    public validationOr!: boolean;

    public validationInfo:string='';

    constructor(){
        this.validationRules = new Array();
        this.validationOr = false;
    }

    public createInputField(fieldDefinitions:FieldDefinition[]){
        if(this.validationRules) {
            this.validationRules.forEach(fr=>{
                fr.createInputField(fieldDefinitions);
                this.validationInfo += fr.inputField?.name + '; ';
            });
        }
        else{
            this.validationInfo="no rules defined";
        }
    }

    public static mapFromDTO(param:ValidationProtocolDTO):ValidationProtocol{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ValidationProtocol();
        try
        {
            obj.id = param.id;
            obj.sequenceNo = param.sequenceNo;
            obj.validationRules = param.validationRules.map(vr=>ValidationRule.mapFromDTO(vr));
            obj.validationOr = param.validationOr;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ValidationProtocol):ValidationProtocolDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ValidationProtocolDTO();
        try
        {
            dto.id = param.id;
            dto.sequenceNo = param.sequenceNo;
            dto.validationRules = param.validationRules.map(vr=>ValidationRule.mapToDTO(vr));
            dto.validationOr = param.validationOr;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    //use DTO to create a deep copy
    get clone():ValidationProtocol{
        //memorize used filterRuleDefinitions first
        let usedValidationRuleDefinitions:ValidationRuleDefinition[]=[];
        this.validationRules.forEach(vr=>{
            if(usedValidationRuleDefinitions.findIndex(vrd=>vrd.id==vr.validationRuleDefinition.id)==-1){
                usedValidationRuleDefinitions.push(vr.validationRuleDefinition);
            }
        });
        let mappedValidationProtocol=ValidationProtocol.mapToDTO(this);
        mappedValidationProtocol.id=0;
        mappedValidationProtocol.validationRules.forEach(vr=>{
            vr.id=0;
        });
        let mapFromDTOValidationProtocol = ValidationProtocol.mapFromDTO(mappedValidationProtocol);
         //relate validationRuleDefinitions with clone
         mapFromDTOValidationProtocol.validationRules.forEach(vr=>{
            vr.validationRuleDefinition=usedValidationRuleDefinitions.find(vrd=>vrd.id==vr.validationRuleDefinitionId)!;
        });
        return mapFromDTOValidationProtocol;
    }

    
}